import { Button, Dialog, Text } from '@noorden-insurtech/alba-design-system';
import { Pencil } from 'lucide-react';

interface AlterProposalDialogProps {
  isOpen: boolean;
  isLoading?: boolean;
  onClose: () => void;
  onConfirm: () => void | Promise<void>;
}

export function AlterProposalDialog({
  isOpen,
  isLoading = false,
  onClose,
  onConfirm,
}: AlterProposalDialogProps) {
  return (
    <Dialog.Root
      open={isOpen}
      onOpenChange={details => {
        if (!details.open && !isLoading) onClose();
      }}
    >
      <Dialog.Backdrop />
      <Dialog.Positioner>
        <Dialog.Content className='w-[640px] max-w-[90vw] rounded-[24px] bg-[#F9F9F9] p-0 shadow-xl'>
          <div className='flex flex-col items-start gap-4 p-6'>
            <Dialog.Header className='w-full p-0'>
              <Dialog.Title className='w-full'>
                <div className='flex w-full items-center justify-between gap-3'>
                  <div className='flex items-center gap-2'>
                    <Pencil className='h-6 w-6 text-alba-black-500' />
                    <Text className='text-lg font-bold text-alba-black-500'>
                      Alterar proposta
                    </Text>
                  </div>
                  <Dialog.CloseButton onClick={onClose} />
                </div>
              </Dialog.Title>
            </Dialog.Header>

            <Dialog.Body className='w-full p-0'>
              <Text className='text-sm text-alba-gray-600'>
                Ao alterar a proposta, essa proposta será cancelada e uma nova
                versão dela ficará disponível para edição.
              </Text>
            </Dialog.Body>

            <Dialog.Footer className='w-full p-0'>
              <div className='flex w-full items-center justify-end gap-6'>
                <Dialog.CloseTrigger asChild>
                  <Button variant='ghost' size='large' disabled={isLoading}>
                    Voltar
                  </Button>
                </Dialog.CloseTrigger>
                <Button
                  variant='primary'
                  size='large'
                  loading={isLoading}
                  disabled={isLoading}
                  onClick={onConfirm}
                >
                  Confirmar
                </Button>
              </div>
            </Dialog.Footer>
          </div>
        </Dialog.Content>
      </Dialog.Positioner>
    </Dialog.Root>
  );
}
